/* RESPONSIBLE TEAM: team-fin-qa */

import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneMonitorEditConversationsConversationRoute extends Route {
  analytics = {
    section: 'standalone',
    place: 'standalone.monitor.edit.conversations.conversation',
  };

  reactEnabled() {
    return true;
  }
}

export default ReactRoute(StandaloneMonitorEditConversationsConversationRoute);
